import { render, staticRenderFns } from "./NsPlot.vue?vue&type=template&id=67da9a0c&scoped=true&"
import script from "./NsPlot.vue?vue&type=script&lang=js&"
export * from "./NsPlot.vue?vue&type=script&lang=js&"
import style0 from "./NsPlot.vue?vue&type=style&index=0&id=67da9a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67da9a0c",
  null
  
)

export default component.exports